import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { GeneralConstants } from 'src/app/core/constants/general.constants';
import { AfipModel } from 'src/app/core/models/afip.model';
import { Afip } from 'src/app/core/models/interfaces/afip';
import { toAfipModel } from 'src/app/core/mappers/afip.mapper';

@Injectable({
  providedIn: 'root'
})
export class AfipService {
  constructor(private rest: RestService) {}

  public async validateCuit(cuit: string): Promise<AfipModel> {
    try {
      let response = await this.rest.get(GeneralConstants.validateCuit + { cuit: cuit });

      if (response.resultCode == -1) {
        return Promise.reject(response.message);
      }
      return Promise.resolve(toAfipModel(<Afip>response.object));
    } catch (error) {
      return Promise.reject(error.message);
    }
  }
}
